import { Action } from '@ngrx/store';

export const ActionTypes = {
	EDIT_FILTER: '[Filter] EDIT_FILTER',
	RESET_STATE: '[Filter] RESET_STATE',
	SET_IS_LOADING: '[Filter] SET_IS_LOADING'
};

export class EditFilterAction implements Action {
	readonly type = ActionTypes.EDIT_FILTER;
	constructor(public payload?: any) {}
}

export class SetIsLoadingAction implements Action {
	readonly type = ActionTypes.SET_IS_LOADING;
	constructor(public payload?: any) {}
}

export type Actions =
	| EditFilterAction
	| SetIsLoadingAction;